import React from 'react';
import usePageTranslation from '../../../shared/hooks/usePageTranslation';
import Navbar from '../../../shared/components/Navbar';
import Footer from '../../../shared/components/Footer';
import BackgroundImage from '../../../shared/components/BackgroundImage';
import Card from '../../../shared/components/Card';

const MentionsLegales: React.FC = () => {
  const { t } = usePageTranslation('public', 'MentionsLegales');

  return (
    <div className="min-h-screen relative">
      <BackgroundImage />
      <Navbar />
      <div className="relative z-10">
        {/* Header de la page */}
        <section className="pt-24 pb-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 text-gradient">
                {t('title')}
              </h1>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                {t('subtitle')}
              </p>
            </div>
          </div>
        </section>

        {/* Contenu principal */}
        <section className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="p-8 md:p-12">
              <div className="prose prose-lg max-w-none">
                <div className="legal-section mb-8">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center">
                    <span className="bg-red-500/20 text-red-400 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold mr-4 border-2 border-red-500/50">
                      1
                    </span>
                    {t('editor.title')}
                  </h2>
                  <p className="text-lg text-gray-300 mb-4">
                    <strong className="text-primary-400">OpSecours</strong> {t('editor.description')}
                  </p>
                  <p className="text-lg text-gray-300 mb-6">
                    {t('editor.purpose')}
                  </p>

                  <h3 className="text-2xl font-semibold text-white mb-4">{t('editor.legalInfo')}</h3>
                  <ul className="space-y-2 mb-6">
                    <li className="flex items-start text-gray-300">
                      <span className="text-red-400 font-bold mr-2">•</span>
                      <strong>{t('editor.owner')} :</strong> Bondi51
                    </li>
                    <li className="flex items-start text-gray-300">
                      <span className="text-red-400 font-bold mr-2">•</span>
                      <strong>{t('editor.director')} :</strong> Bondi51
                    </li>
                    <li className="flex items-start text-gray-300">
                      <span className="text-red-400 font-bold mr-2">•</span>
                      <strong>{t('editor.email')} :</strong>{' '}
                      <a href="mailto:support@opsecours.fr" className="text-primary-400 hover:text-primary-300 underline">
                        support@opsecours.fr
                      </a>
                    </li>
                  </ul>

                  <h3 className="text-2xl font-semibold text-white mb-4">{t('editor.team')}</h3>
                  <ul className="space-y-2">
                    <li className="flex items-start text-gray-300">
                      <span className="text-blue-400 font-bold mr-2">•</span>
                      <strong>{t('editor.mainDev')} :</strong> Bondi51
                    </li>
                    <li className="flex items-start text-gray-300">
                      <span className="text-blue-400 font-bold mr-2">•</span>
                      <strong>{t('editor.dev')} :</strong> Jeje181557
                    </li>
                    <li className="flex items-start text-gray-300">
                      <span className="text-blue-400 font-bold mr-2">•</span>
                      <strong>{t('editor.designer')} :</strong> HyDroX_Tv
                    </li>
                  </ul>
                </div>

                <div className="legal-section mb-8">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center">
                    <span className="bg-blue-500/20 text-blue-400 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold mr-4 border-2 border-blue-500/50">
                      2
                    </span>
                    {t('hosting.title')}
                  </h2>
                  <p className="text-lg text-gray-300 mb-4">{t('hosting.description')}</p>
                  <ul className="space-y-2">
                    <li className="flex items-start text-gray-300">
                      <span className="text-blue-400 font-bold mr-2">•</span>
                      <strong>{t('hosting.host')} :</strong> Hostinger
                    </li>
                    <li className="flex items-start text-gray-300">
                      <span className="text-blue-400 font-bold mr-2">•</span>
                      <strong>{t('hosting.address')} :</strong> 123 Rue de l'Internet, 75000 Paris, France
                    </li>
                    <li className="flex items-start text-gray-300">
                      <span className="text-blue-400 font-bold mr-2">•</span>
                      <strong>{t('hosting.phone')} :</strong> +33 1 23 45 67 89
                    </li>
                  </ul>
                </div>

                <div className="legal-section mb-8">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center">
                    <span className="bg-green-500/20 text-green-400 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold mr-4 border-2 border-green-500/50">
                      3
                    </span>
                    {t('intellectual.title')}
                  </h2>
                  <p className="text-lg text-gray-300 mb-4">
                    {t('intellectual.description1')}
                  </p>
                  <p className="text-lg text-gray-300">
                    {t('intellectual.description2')}
                  </p>
                </div>

                <div className="legal-section mb-8">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center">
                    <span className="bg-yellow-500/20 text-yellow-400 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold mr-4 border-2 border-yellow-500/50">
                      4
                    </span>
                    {t('links.title')}
                  </h2>
                  <p className="text-lg text-gray-300">
                    {t('links.description')}
                  </p>
                </div>

                <div className="legal-section mb-8">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center">
                    <span className="bg-purple-500/20 text-purple-400 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold mr-4 border-2 border-purple-500/50">
                      5
                    </span>
                    {t('cookies.title')}
                  </h2>
                  <p className="text-lg text-gray-300">
                    {t('cookies.description')}
                  </p>
                </div>

                <div className="legal-section mb-8">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center">
                    <span className="bg-indigo-500/20 text-indigo-400 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold mr-4 border-2 border-indigo-500/50">
                      6
                    </span>
                    {t('liability.title')}
                  </h2>
                  <p className="text-lg text-gray-300 mb-4">
                    {t('liability.description1')}
                  </p>
                  <p className="text-lg text-gray-300">
                    {t('liability.description2')}
                  </p>
                </div>

                <div className="legal-section mb-8">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center">
                    <span className="bg-pink-500/20 text-pink-400 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold mr-4 border-2 border-pink-500/50">
                      7
                    </span>
                    {t('law.title')}
                  </h2>
                  <p className="text-lg text-gray-300">
                    {t('law.description')}
                  </p>
                </div>

                <div className="legal-section mb-8">
                  <h2 className="text-3xl font-bold text-white mb-4 flex items-center">
                    <span className="bg-orange-500/20 text-orange-400 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold mr-4 border-2 border-orange-500/50">
                      8
                    </span>
                    {t('contact.title')}
                  </h2>
                  <p className="text-lg text-gray-300 mb-4">
                    {t('contact.description')}
                  </p>
                  <ul className="space-y-2 mb-4">
                    <li className="flex items-start text-gray-300">
                      <span className="text-orange-400 font-bold mr-2">•</span>
                      <strong>{t('contact.discord')} :</strong> {t('contact.discordAction')}
                    </li>
                    <li className="flex items-start text-gray-300">
                      <span className="text-orange-400 font-bold mr-2">•</span>
                      <strong>{t('contact.email')} :</strong>{' '}
                      <a href="mailto:support@opsecours.fr" className="text-primary-400 hover:text-primary-300 underline">
                        support@opsecours.fr
                      </a>
                    </li>
                    <li className="flex items-start text-gray-300">
                      <span className="text-orange-400 font-bold mr-2">•</span>
                      <strong>{t('contact.owner')} :</strong> Bondi51
                    </li>
                  </ul>
                  <p className="text-lg text-gray-300">
                    <strong>{t('contact.note')}</strong>
                  </p>
                </div>

                <div className="mt-12 p-6 bg-gradient-to-r from-gray-800/50 to-blue-900/50 rounded-xl border-l-4 border-blue-500">
                  <p className="text-lg font-semibold text-white">
                    <strong>{t('lastUpdate')} :</strong> 01/07/2024
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default MentionsLegales;

